import { AppDispatch } from "../../../store";
import { ensureAclGlobalLevel } from "../../../acl/asyncActions";
import { ensureCustomer } from "../../../redux/modules/customers/reducer";
import { fetchSites } from "../../../redux/modules/sites/actions";
import { putCurrentSiteData } from "../../../redux/modules/currentSite/reducer";

export const userOpensSiteListPage = (customerId: string) => async (
  dispatch: AppDispatch,
): Promise<void> => {
  if (!customerId) {
    return;
  }
  await Promise.all([
    await dispatch(ensureAclGlobalLevel()),
    await dispatch(ensureCustomer(customerId)),
    await dispatch(fetchSites(customerId)),
    await dispatch(putCurrentSiteData(null)),
  ]);
};
